import { render, staticRenderFns } from "./ManagerCreateAndUpdateFormItems.vue?vue&type=template&id=5a25e625&"
import script from "./ManagerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ManagerCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a25e625')) {
      api.createRecord('5a25e625', component.options)
    } else {
      api.reload('5a25e625', component.options)
    }
    module.hot.accept("./ManagerCreateAndUpdateFormItems.vue?vue&type=template&id=5a25e625&", function () {
      api.rerender('5a25e625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManagerCreateAndUpdateFormItems.vue"
export default component.exports